<isData class="is-data-wrapper" [inProgress]="loading" [noDataIf]="!jsonData">
  @switch (type) {
    @case ('flow') {
      <tap-flow [data]="jsonData"></tap-flow>
    }
    @case ('rtp-streams') {
      <tap-rtp-streams [data]="jsonData"></tap-rtp-streams>
    }
    @case ('voip-calls') {
      <tap-voip-calls [data]="jsonData"></tap-voip-calls>
    }
    @case ('follow') {
      <follow-stream [data]="jsonData"></follow-stream>
    }
    @case ('frame') {
      <div class="frame-detail">
        <div class="frame-tree">
          <tree-filter [data]="jsonData.tree" [isFilter]="true"></tree-filter>
        </div>
        <div class="frame-hex">
          <app-frame-hex [b64data]="jsonData.bytes"></app-frame-hex>
        </div>
      </div>
    }
    @case ('iograph') {
      <io-graph [data]="jsonData"></io-graph>
    }
    @case ('eo') {
      <div class="eo-list">
        @for (item of jsonData?.objects || []; track item; let i = $index) {
          <button
            type="button"
            (click)="downloadObject(item, i)"
            >
            {{ item.filename || item.name || ('object ' + i) }}
          </button>
        }
      </div>
      <chart-and-table [data]="jsonData" (rowClick)="onRowClick($event)"></chart-and-table>
    }
    @default {
      <chart-and-table [data]="jsonData" (rowClick)="onRowClick($event)"></chart-and-table>
    }
  }
</isData>
